export default function selectFirstTab(tabsSelector, contentsSelector) {
  try {
    const productDescriptionTabs = document.querySelectorAll(tabsSelector);
    if (productDescriptionTabs.length === 0) {
      return;
    }
    const productDescriptionContents = document.querySelectorAll(contentsSelector);
    if (productDescriptionContents.length === 0
      || productDescriptionContents.length !== productDescriptionTabs.length) {
      throw new Error('Error product-description-tabs');
    }

    const firstTab = productDescriptionTabs[0];
    const currentContentHash = new URL(firstTab.href).hash;

    let currentContent;
    productDescriptionContents.forEach((el) => {
      if (currentContentHash === `#${el.id}`) {
        currentContent = el;
      }
    });

    if (currentContent === undefined) {
      throw new Error('Error product-description-tabs');
    }

    firstTab.classList.add('active');
    currentContent.classList.add('show', 'active');
  } catch (e) {
    // eslint-disable-next-line
    console.error('Error product-description-tabs');
  }
}
